
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";

export function usePlanSelection() {
  const [selectedPlanId, setSelectedPlanId] = useState<string | null>(null);
  const { toast } = useToast();

  const handleSelectPlan = (planId: string) => {
    if (!planId) {
      toast({
        title: "Error",
        description: "Please select a valid plan",
        variant: "destructive",
      });
      return;
    }

    setSelectedPlanId(planId);
    
    // Success notification
    toast({
      title: "Plan Selected",
      description: "You've selected a subscription plan",
    });
  };

  return {
    selectedPlanId,
    handleSelectPlan
  };
}
